
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import { mapState } from "vuex";

export default {
  props: {
    data: {
      type: Object,
    },
  },
  components: {
    Swiper,
    SwiperSlide,
  },
  computed: {
    ...mapState("videos", { videos: (state) => state.videos.data }),
  },
};
